import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import colors from "../../assets/style/colors";

const styles = {
  container: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px",
    minHeight: "250px",
    height: "calc(100% - 58px)"
  }
};

class StructuralView extends Component {
  mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      displayDetails: {}
    };
  }

  componentDidMount() {
    this.mounted = true;
    console.log("componentDidMount");
  }

  componentWillUnmount() {
    this.mounted = false;
    console.log("componentWillUnmount");
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
  }

  closeTab = async id => {};

  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
      >
        <Grid item>
          <text>StructuralView is coming soon</text>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.user.language
  };
};

export default connect(mapStateToProps)(withStyles(styles)(StructuralView));
